import type { Vec3 } from "../core";

/** Resolve yaw in the canonical basis: +Y is up and +Z is forward. */
export function resolveTargetFacingYaw(origin: Vec3, target: Vec3 | undefined, fallbackYaw = 0): number {
  if (!target) return fallbackYaw;
  const dx = target.x - origin.x;
  const dz = target.z - origin.z;
  if (dx * dx + dz * dz < 1e-8) return fallbackYaw;
  return Math.atan2(dx, dz);
}

/** Convert a world-space direction into an actor's yaw-relative local basis. */
export function worldDirectionToLocal(direction: Vec3, actorYaw: number): Vec3 {
  const sine = Math.sin(actorYaw);
  const cosine = Math.cos(actorYaw);
  return {
    x: cosine * direction.x - sine * direction.z,
    y: direction.y,
    z: sine * direction.x + cosine * direction.z,
  };
}
